var exports = {
  "N": "MentionTooltipContent.module__card___WjZyYn",
};

module.exports = exports;
